import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { BACKEND_URL, CONSUMER_URL } from "../../../../helpers/variables";
import { Autocomplete, TextField } from "@mui/material";
import { useLoaderData } from "react-router-dom";
import { enqueueSnackbar } from "notistack";

export const Contract = ({ invoice }) => {
  const { client_url } = useLoaderData();
  const { values, setFieldValue } = useFormikContext();
  const { vendor } = values;

  const [contractList, setContractList] = useState(null);

  useEffect(() => {
    setContractList(null);
    setFieldValue("contract", null);

    async function fetchContractList() {
      let res = await fetch(
        `${CONSUMER_URL}/contract_list?vendor_id=${vendor["id"]}&client_url=${client_url}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(invoice),
        }
      );

      if (res.status === 200) {
        let { contract, contract_list } = await res.json();
        setContractList(contract_list);
        setFieldValue("contract", contract);
      } else {
        let data = await res.text();
        setContractList([]);
        // enqueueSnackbar(data, { variant: "error" });
      }
    }

    if (vendor) fetchContractList();
  }, [vendor]);

  return (
    <Autocomplete
      value={values["contract"]}
      disabled={contractList?.length === 0}
      size="small"
      loading={!Boolean(contractList)}
      options={contractList || []}
      getOptionLabel={(option) => option.accountNumber || "NA"}
      onChange={(_, v) => setFieldValue("contract", v)}
      renderInput={(params) => <TextField {...params} label="Contracts" />}
    />
  );
};
